// extracted by mini-css-extract-plugin
export var cartItem = "_r-3";
export var drawerContent = "_r-0";
export var emptyCart = "_r-2";
export var fadeIn = "_r-4";
export var imagePlaceholder = "_r-6";
export var itemImage = "_r-5";
export var itemsContainer = "_r-1";